import { SaveManager } from './SaveManager';
import { LocalAdapter } from './adapters/LocalAdapter';
import { ServerSaveAdapter } from './adapters/ServerSaveAdapter';

/**
 * Singleton save managera.
 *
 * Używany wszędzie: Phaser scene reads `saveManager.getCurrent()`, React UI
 * też. Inicjalizacja przez `await saveManager.load()` na starcie aplikacji
 * (`main.tsx`) — DOPIERO po `waitForAuthCompletion()` (ServerSaveAdapter
 * woła API z cookie).
 *
 * Phase 1 (MVP): LocalAdapter (IndexedDB).
 * Phase 4 (Online, sesja 34B): ServerSaveAdapter — persistence przez backend.
 * LocalAdapter przekazany jako fallback służy do jednorazowego importu
 * istniejącego IDB save przy pierwszym loginie (potem jest kasowany).
 */
export const saveManager = new SaveManager(
  new ServerSaveAdapter(new LocalAdapter()),
);

export { SAVE_VERSION } from './PlayerSave.schema';
export { createInitialSave } from './PlayerSave.schema';
export type { PlayerSave } from './PlayerSave.schema';
